// src/queries/users.js
// Thin API client for the tenant-users endpoint. Mirrors queries/entitlements.js
// exactly — RequestBuilder handles auth + retry; every module chains
// `.then(toJSON)` since RequestBuilder.fetch() resolves to the raw Response.
import { RequestBuilder, toJSON } from "./request";

const BASE = "/api/admin/entitlements/users";

export const fetchTenantUsers = (authData) =>
  new RequestBuilder(BASE)
    .withAuthorization(authData)
    .withJSONContentType()
    .fetch()
    .then(toJSON);
